import Vue from 'vue';
import Router from 'vue-router';
import auth from '@/helpers/auth';

Vue.use(Router);

const isAuth = (to, from, next) => {
	if (!auth.loggedIn()) {
		next({
			name: 'login',
			query: { redirect: to.fullPath },
		});
	} else {
		next();
	}
};

const isUnauth = (to, from, next) => {
	if (auth.loggedIn()) {
		if (from.name == null) {
			next({ name: 'dashboard' });
		} else {
			next({ name: from.name });
		}
	} else {
		next();
	}
};

export default new Router({
	mode: 'history',
	duplicateNavigationPolicy: 'ignore',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/login',
			name: 'login',
			beforeEnter: isUnauth,
			component: () => import('@/views/vo-general/autentikasi/Login.vue'),
		},
		{
			path: '/sso/:token',
			name: 'sso',
			component: () => import('@/views/vo-general/autentikasi/LoginSSO.vue'),
		},
		{
			path: '/',
			beforeEnter: isAuth,
			component: () => import('@/components/layout/vo-general/Main.vue'),
			children: [
				{
					path: '/',
					name: 'dashboard',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/dashboard/Dashboard.vue')
				},
				{
					path: '/profil',
					name: 'profil',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/profil/profil/Profil.vue')
				},
				{
					path: '/ubah-password',
					name: 'ubah-password',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/profil/ubahPassword/UbahPassword.vue')
				},
				{
					path: '/registrasi',
					name: 'registrasi',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan/registrasi/Registrasi.vue')
				},
				{
					path: '/genealogy',
					name: 'genealogy',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan/genealogy/Genealogy.vue')
				},
				{
					path: '/sponsor-pribadi',
					name: 'sponsor-pribadi',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan/sponsorPribadi/SponsorPribadi.vue')
				},
				{
					path: '/pertumbuhan-jaringan',
					name: 'pertumbuhan-jaringan',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan/pertumbuhanJaringan/PertumbuhanJaringan.vue')
				},
				{
					path: '/downline',
					name: 'downline',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan/downline/Downline.vue')
				},
				{
					path: '/beli-produk',
					name: 'beli-produk',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/transaksiProduk/beliProduk/BeliProduk.vue')
				},
				{
					path: '/data-pembelian',
					name: 'data-pembelian',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/transaksiProduk/dataPembelian/DataPembelian.vue')
				},
				{
					path: '/data-pembelian/:type/:slug',
					name: 'detail-pembelian',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/transaksiProduk/dataPembelian/DetailPembelian.vue')
				},
				{
					path: '/data-produk',
					name: 'data-produk',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/produk/dataProduk/DataProduk.vue')
				},
				{
					path: '/tambah-ro',
					name: 'tambah-ro',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/repeatOrder/tambahRO/TambahRO.vue')
				},
				{
					path: '/riwayat-ro',
					name: 'riwayat-ro',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/repeatOrder/riwayatRO/RiwayatRO.vue')
				},
				{
					path: '/summary-komisi',
					name: 'summary-komisi',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi/summaryKomisi/SummaryKomisi.vue')
				},
				{
					path: '/histori-komisi',
					name: 'histori-komisi',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi/historiKomisi/HistoriKomisi.vue')
				},
				{
					path: '/klaim-komisi',
					name: 'klaim-komisi',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi/klaimKomisi/KlaimKomisi.vue')
				},
				{
					path: '/histori-transfer',
					name: 'histori-transfer',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi/historiTransfer/HistoriTransfer.vue')
				},
				{
					path: '/list-reward',
					name: 'list-reward',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/reward/listReward/ListReward.vue')
				},
				{
					path: '/reward-saya',
					name: 'histori-reward',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/reward/rewardSaya/RewardSaya.vue')
				},
				{
					path: '/testimoni',
					name: 'testimoni',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/testimoni/Testimoni.vue')
				},
				{
					path: '/detail-komisi-unilevel',
					name: 'detail-komisi-unilevel',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi/detailUnilevel/DetailUnilevel.vue')
				},
				{
					path: '/buat-pesan/:code?',
					name: 'buat-pesan',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/pesan/buatPesan/BuatPesan.vue')
				},
				{
					path: '/pesan-masuk',
					name: 'pesan-masuk',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/pesan/pesanMasuk/PesanMasuk.vue')
				},
				{
					path: '/pesan-terkirim',
					name: 'pesan-terkirim',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/pesan/pesanTerkirim/PesanTerkirim.vue')
				},
				{
					path: '/arsip',
					name: 'arsip',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/pesan/arsip/Arsip.vue')
				},
				{
					path: '/detail-pesan-masuk/:id?',
					name: 'detail-pesan-masuk',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/pesan/pesanMasuk/components/DetailPesan.vue')
				},
				{
					path: '/detail-pesan-terkirim/:id?',
					name: 'detail-pesan-terkirim',
					beforeEnter: isAuth,
					component: () => import ('@/views/vo-general/pesan/pesanTerkirim/components/DetailPesan.vue')
				},
			]
		},
		{
			path: '*',
			component: () => import('@/components/layout/vo-general/ErrorPage.vue'),
			children: [
				{
					path: '/maintenance',
					component: () => import('@/views/Maintenance.vue')
				},
				{
					path: '*',
					name: 'not-found',
					component: () => import('@/views/404.vue')
				}
			]
		}
	],
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	}
});